const Dashboard = () => import('@/views/private/Dashboard.vue')
const MarketplaceClassCollection = () => import('@/views/public/marketplace/class/Collection.vue')
const MarketplaceLibraryCollection = () => import('@/views/public/marketplace/library/Collection.vue')
const Cart = () => import(/* webpackPrefetch: true */ '@/views/private/cart/Index.vue')
const Transaction = () => import(/* webpackPrefetch: true */ '@/views/private/transaction/Index.vue')
const Purchasing = () => import(/* webpackPrefetch: true */ '@/views/private/purchasing/Index.vue')
const PurchasingDetail = () => import(/* webpackPrefetch: true */ '@/components/purchasing/Detail.vue')
const PurchasingConfirmation = () => import(/* webpackPrefetch: true */ '@/components/purchasing/Confirmation.vue')
const PurchasingSuccess = () => import(/* webpackPrefetch: true */ '@/components/purchasing/Success.vue')
const Bill = () => import(/* webpackPrefetch: true */ '@/views/private/bill/Index.vue')
const BillConfirmation = () => import(/* webpackPrefetch: true */ '@/components/bill/Confirmation.vue')
const BillDetail = () => import(/* webpackPrefetch: true */ '@/components/bill/Detail.vue')
const BillSuccess = () => import(/* webpackPrefetch: true */ '@/components/bill/Success.vue')
const Notification = () => import(/* webpackPrefetch: true */ '@/views/private/Notification.vue')

const routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      title: 'Dashboard'
    }
  },
  {
    path: '/marketplace/class/collection/:id',
    name: 'class collection',
    component: MarketplaceClassCollection,
    meta: {
      title: 'Koleksi'
    }
  },
  {
    path: '/marketplace/library/collection/:id',
    name: 'library collection',
    component: MarketplaceLibraryCollection,
    meta: {
      title: 'Koleksi'
    }
  },
  {
    path: '/cart',
    name: 'cart',
    component: Cart,
    meta: {
      title: "Keranjang"
    }
  },
  {
    path: '/transaction',
    name: 'transaction',
    component: Transaction,
    meta: {
      title: "Transaksi"
    }
  },
  {
    path: "/purchasing",
    name: "purchasing",
    component: Purchasing,
    meta: {
      title: "Pembelian"
    },
    children: [
      {
        path: '/purchasing/detail/:id',
        name: 'purchasing detail',
        component: PurchasingDetail,
        meta: {
          title: "Pembelian"
        }
      },
      {
        path: '/purchasing/confirmation/:id',
        name: 'purchasing confirmation',
        component: PurchasingConfirmation,
        meta: {
          title: "Konfirmasi Pembelian"
        }
      },
      {
        path: '/purchasing/success/:id',
        name: 'purchasing success',
        component: PurchasingSuccess,
        meta: {
          title: "Pembelian Berhasil"
        }
      }
    ]
  },
  ,
  {
    path: "/bill",
    name: " bill",
    component: Bill,
    meta: {
      title: "Pembayaran Tagihan"
    },
    children: [
      {
        path: '/bill/detail/:id',
        name: ' bill detail',
        component: BillDetail,
        meta: {
          title: "Detail Pembayaran"
        }
      },
      {
        path: '/bill/confirmation/:id',
        name: ' bill confirmation',
        component: BillConfirmation,
        meta: {
          title: "Konfirmasi Pembayaran"
        }
      },
      {
        path: '/bill/success/:id',
        name: ' bill success',
        component: BillSuccess,
        meta: {
          title: "Pembayaran Berhasil"
        }
      }
    ]
  },
  {
    path: "/notification",
    name: "notification",
    component: Notification,
    meta: {
      title: "Pemberitahuan"
    }
  },
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})